import { AppRoutes } from './routes';
import { BrandingRuntime } from './components/branding/BrandingRuntime';

export function App() {
  return (
    <>
      <BrandingRuntime />
      <AppRoutes />
    </>
  );
}
